import { render, staticRenderFns } from "./listSuccessCase.vue?vue&type=template&id=8196aaa4&"
import script from "./listSuccessCase.vue?vue&type=script&lang=js&"
export * from "./listSuccessCase.vue?vue&type=script&lang=js&"
import style0 from "./listSuccessCase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports